module.exports = __webpack_public_path__ + "static/media/gifts-active-icon.fd845748.svg";